/**
 * Resolve the journal an invoice or credit note posts to.
 *
 * This used to be an exact `code === 'SAL' || code === 'INV'` match at every
 * call site. Shoptoplus Logistics' sales journal is coded "INV/SL" so its
 * journal entry numbers carry that company's invoice prefix — the exact match
 * then found nothing, and Confirm / Send / Cancel failed on every invoice of
 * that company with "Missing required accounts or journal".
 *
 * Matching on `type === 'SALE'` alone would not be safe: some companies also
 * carry a SALE-typed "Cash Basis Taxes" journal, and silently posting there is
 * worse than the error. So the order is: the exact historical codes, then the
 * per-company prefixed form (INV/SL, SAL-HK, …), then a SALE journal that names
 * itself for invoices.
 */
export const findSalesJournal = (journals: any[]): any | undefined => {
  if (!Array.isArray(journals)) return undefined;
  const codeOf = (j: any) => String(j?.code ?? '');
  const nameOf = (j: any) => String(j?.name ?? '');
  return (
    journals.find((j) => codeOf(j) === 'SAL' || codeOf(j) === 'INV') ||
    journals.find((j) => /^(INV|SAL)[/\-_]/i.test(codeOf(j))) ||
    journals.find((j) => j?.type === 'SALE' && /invoice|sales/i.test(nameOf(j)))
  );
};
